import React, { Component } from 'react';
import "./Login.css"
import logo from "../img/logo x home.png"

import{
    Container,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Row,
    Modal,
    ModalBody,
    ModalFooter,    
} from 'reactstrap';

import { Recupero } from '../components/Utenti/Recupero';

export class Login extends Component {
    constructor(props) {
        super(props);

        this.toggleRecuperoModal = this.toggleRecuperoModal.bind(this)

        this.state = {
            UserName: "",
            Password: "",
            RecuperoModal: false
        };
    }
    

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    toggleRecuperoModal = () => {
        this.setState({
            RecuperoModal: !this.state.RecuperoModal
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const form = {
            UserName: this.state.UserName,
            Password: this.state.Password
        }        

        const headers = new Headers({
            "Content-Type": "application/json",
        })

        fetch('../api/login',  {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(form)
        }).then(response => response.json())
        .then(response => {
            sessionStorage.setItem("auth", response.token);
            sessionStorage.setItem("authExp", response.expiration);
            sessionStorage.setItem("role", JSON.stringify(response.role))
            sessionStorage.setItem("nome", response.utenti)

            this.setState({
                UserName: "",
                Password: ""
            });
           
            if(response.role[0] === 'Superuser'){
                this.props.setRole("Agenti");
            }
            else{
                this.props.setRole(response.role[0]);
            }
            
            this.props.history.goBack();
            
        })
        .catch(error => {
            console.log(error);
            document.getElementById("Error").style.display = "inline";
        });

        
    }

    render() {
        return (
            <Container className="App d-flex h-100 flex-column" style={{minHeight: '100vh'}}>
                <Row className="justify-content-center align-items-center h-100" style={{minHeight: '100vh'}}>
                    <Col className="my-auto">
                        <Row className="justify-content-center align-items-center">
                            <Col className="my-auto text-center">
                                <img style={{height: '45%', width: '45%'}}src={logo} alt="Renieri"></img>
                            </Col>
                        </Row>
                        <Row className="justify-content-center align-items-center" style={{paddingTop: "4vh"}} >
                            <Col className="my-auto" style={{width: '1vw'}}>
                                <Row className="justify-content-center align items center">                  
                                    <Form className="form"  onSubmit={this.handleSubmit}>
                                        <Col style={{ paddingTop: "1vh" }}>
                                            <FormGroup className="row">
                                                <Label for="UserName" className="col-3 col-form-label" style={{color: '#011e41'}}>Utente</Label>
                                                <Col className="col-9">
                                                    <Input type="text" name="UserName" id="UserName" placeholder="Username" onChange={this.handleChange}/>
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup className="row">
                                            <Label for="Password" className="col-3 col-form-label" style={{color: '#011e41'}}>Password</Label>
                                                <Col className="col-9">
                                                    <Input type="password" name="Password" id="Password" placeholder="Password" onChange={this.handleChange}/>
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                        <Col className="text-center" style={{paddingTop: "1vh", paddingBottom: "1vh"}}>
                                            <Button className="text-center " style={{width: '30%', padding: '0px', backgroundColor: "#011e41"}}>
                                                Login
                                            </Button>
                                        </Col>  
                                        <Col>
                                            <p id="Error" style={{color: 'red', display: 'none'}}>Errore: Controlla il tuo nome utente e password</p>
                                        </Col>
                                    </Form>
                                </Row>
                            </Col>  
                        </Row>
                      
                    </Col>
                </Row>
                    
                   
               
            <Modal size="md" isOpen={this.state.RecuperoModal} toggle={this.toggleRecuperoModal} style={{ fontSize: "22px", color: "#011e41" }}>
                <ModalBody>
                    <Recupero
                        toggleRecuperoModal={this.toggleRecuperoModal}
                    />
                </ModalBody>                    
                <ModalFooter>
                    <Button type="button" className="text-center" onClick={this.toggleRecuperoModal} style={{ width: '30%', padding: '0px', backgroundColor: "#011e41" }}>
                        Annulla
                </Button>
                    <Button type="button" className="text-center" onClick={this.toggleRecuperoModal} style={{ width: '30%', padding: '0px', backgroundColor: "#011e41" }}>
                        Recupera Passsword
                    </Button>
                </ModalFooter>
            </Modal>
            </Container>
        )
    }
}

               //PULSANTE RECUPERO PASSWORD
/* < Row className = "justify-content-center align-items-center" >
    <Col className="text-center text-decoration" style={{ paddingTop: "1vh" }}>
        <a onClick={this.toggleRecuperoModal}> Recupera Passsword</a>
    </Col>
    </Row >*/      


// WEBPACK FOOTER //
// ./src/components/Login.js